import React, { Component } from 'react'
import { Button, Select, TextInput } from 'advenio-components'
import styled from 'styled-components'
import { clone } from 'ramda'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import moment from 'moment'
import Rating from '../ParentPlatform/RatingModal/Rating'
import { NameHeader, Close, Save, Img } from './ModalAssessment.styles'
import CheckinInventoryActions from '../../Data/Redux/CheckinInventoryRedux'
import { generateSelectOptions ,studentIsExternal} from '../../utils/Utils'

const Content = styled.div`
  flex: 1;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  @media (max-width: 763px) {
    height: calc(100vh - 100px);
    overflow-y: scroll;
    display: block;
  }
`

const CheckoutContent = styled.div`
  flex: 1;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const HeaderTitle = styled.div`
  flex: 1;
  height: 80px;
  border-bottom: solid 1px;
  border-bottom-color: #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const NameSpan = styled.span`
  color: #4a4a4a;
`

const HeaderSpan = styled.span`
  font-size: 14px;
`

const Profile = styled.div`
  background-image: ${props =>
    props.profile ? `url(${props.profile})` : 'url(/assets/BabyAvatar.svg)'};
  background-size: cover;
  background-position: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: solid #cccccc 1px;
  margin-right: 4px;
`

export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
`

const SelectDiv = styled.div`
  width: 80%;
  display: ${props =>
    props.rating ? `inline-block` : 'flex'};
  justify-content: flex-start';
  align-items: center;
  @media (max-width: 763px) {
    width: 100%;
  }
`

const Label = styled.div`
  width: 40%;
`
const SelectComponent = styled.div`
  flex: 1;
  flex-basis: 60%;
`

const CheckoutFormContainer = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
class CheckinModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      disabled: true,
      medications: [
        {
          id: 0,
          label: 'Seleccionar Med',
          value: 0,
        },
      ],
      mood: [
        {
          id: 0,
          label: 'Seleccionar Mood',
          value: 0,
        },
      ],
      incidentTypes: [
        {
          id: 0,
          label: 'Seleccionar Accidente',
          value: 0,
        },
      ],
      options: this.props.fillOptions(10),
      optionsDiaper: this.props.fillOptions(40),
      currentRating: 0,
      diapers: '',
      change_of_clothes:''
    }
  }

  componentDidMount = () => {
    // const { emergencyMedications, mood, incidentTypes } = this.props
    // const newEmergencyMedications = clone(emergencyMedications)
    //   .sort((med1, med2) => (med1.order > med2.order ? 1 : -1))
    //   .map(med => ({
    //     label: med.name,
    //     value: med.id,
    //     id: med.id,
    //   }))
    // const newMood = clone(mood)
    //   .sort((m1, m2) => (m1.order > m2.order ? 1 : -1))
    //   .map(m => ({
    //     label: m.name,
    //     value: m.id,
    //     id: m.id,
    //   }))
    // const newIncidentTypes = clone(incidentTypes)
    //   .sort((type1, type2) => (type1.order > type2.order ? 1 : -1))
    //   .map(type => ({
    //     label: type.name,
    //     value: type.id,
    //     id: type.id,
    //   }))
    // this.setState({
    //   medications: newEmergencyMedications,
    //   mood: newMood,
    //   incidentTypes: newIncidentTypes,
    // })
  }

  componentWillReceiveProps(nextProps) {
    // const { emergencyMedications, mood, incidentTypes } = nextProps
    // const newEmergencyMedications = clone(emergencyMedications)
    //   .sort((med1, med2) => (med1.order > med2.order ? 1 : -1))
    //   .map(med => ({
    //     label: med.name,
    //     value: med.id,
    //     id: med.id,
    //   }))
    // const newMood = clone(mood)
    //   .sort((m1, m2) => (m1.order > m2.order ? 1 : -1))
    //   .map(m => ({
    //     label: m.name,
    //     value: m.id,
    //     id: m.id,
    //   }))
    // const newIncidentTypes = clone(incidentTypes)
    //   .sort((type1, type2) => (type1.order > type2.order ? 1 : -1))
    //   .map(type => ({
    //     label: type.name,
    //     value: type.id,
    //     id: type.id,
    //   }))
    // this.setState({
    //   medications: newEmergencyMedications,
    //   mood: newMood,
    //   incidentTypes: newIncidentTypes,
    // })
  }

  closeModal = () => {
    if (this.props.type === 'checkin') {
      this.props.closeCheckIn()
    } else {
      this.props.closeCheckOut()
    }
  }

  formatFormData = (data) => {
    let dataFormated = {}
    Object.keys(data).map((key) => {
      if (key === 'mood_id' || key === 'emergency_medication_id' || key === 'incident_id') {
        if (data[key] === 0 || data[key] === ' ') {
          dataFormated[key] = null
        } else {
          dataFormated[key] = data[key]
        }
      } else if (key === 'diapers' || key === 'change_of_clothes') {
        if (data[key] === ' ') {
          dataFormated[key] = '0'
        } else {
          dataFormated[key] = data[key]
        }
      } else {
        dataFormated[key] = !data[key] ? null : data[key]
      }
      return key
    })
    // descommment to producction
    if(studentIsExternal(this.props.child)){
      dataFormated = {
        ...dataFormated,
        ratingchild: this.state.currentRating
      }
    }
    return dataFormated
  }

  send = (data) => {
    const { child } = this.props
    const isMayor = true //this.studyProgram(child.study_program_id,child)
    let emtyCheckout = {
      diapers: 0,
      change_of_clothes: 0,
      checkout_time: data.checkout_time,
    }
    window.gtag('event', 'Checkout ', {
      event_category: 'Check',
      event_label: 'click Checkout',
      // value: Number(id)
    })

    // descommment to producction

    if(this.state.currentRating === 0 && studentIsExternal(child)){
      return false
    }

    // descommment to producction
    if(studentIsExternal(child)){
      emtyCheckout={
        ...emtyCheckout,
        ratingchild: this.state.currentRating
      }
    }
    this.props.postStudentCheckOut(
      this.props.child.checkin,
      isMayor ? emtyCheckout : this.formatFormData(data),
      this.props.isTeacher
    )
  }

  studyProgram = (studyProgramId,child = null) => {
    // if( child.checkin.is_virtual_center ) return true
    // const { programLevels } = this.props
    //FIX: All show check Out Modal Generic (muestra solo modal generico de Hora salida).
    return true
    if (studyProgramId) {
      const studyProgram = this.props.studyPrograms.find(program => program.id === studyProgramId)
      const level = programLevels.find(levelProgram => levelProgram.id === studyProgram.level_id)
      return level && level.name !== 'Guardería'
    }
    return false
  }

  // descommment to producction
  validateData = ({ diapers, change_of_clothes }) => {
    const { child } = this.props
    this.setState({ disabled: !((diapers && diapers !== ' ') && (change_of_clothes && change_of_clothes !== ' ') && (child.status_id === 5 ? this.state.currentRating > 0 : true)), diapers, change_of_clothes })
  }

  handleRatingChange = (rating) => {
    const { diapers, change_of_clothes } = this.state
    this.setState({ currentRating: rating }
      // ,this.validateData({diapers, change_of_clothes})
      )
  }

  render() {
    const { child, loading, type } = this.props
    const {
      width,
      diapersSelected,
      optionsDiaper,
      options,
      clothesSelected,
      medications,
      mood,
      incidentTypes,
      disabled,
    } = this.state

    // this.studyProgram(child.study_program_id,child) ?
    return (
      <div>
        <Form onSubmit={this.send} >
          <HeaderTitle>
            <Close>
              <Img src="/assets/Close.svg" onClick={this.closeModal} />
            </Close>
            <HeaderSpan>Confirmar salida</HeaderSpan>
            <NameHeader>
              <Profile profile={child.profile_pictures ? child.profile_pictures['original'] : '/assets/BabyAvatar.svg'} />
              <NameSpan>{`${child.first_name} ${child.last_name_paternal}`}</NameSpan>
            </NameHeader>
            <Save>
              <Button
                small
                style={width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}}
                primary
                type="submit"
                loading={loading}
              >
                Confirmar
              </Button>
            </Save>
          </HeaderTitle>
          <CheckoutContent>
            <CheckoutFormContainer>
            {/* // descommment to producction */}
               {studentIsExternal(child) && (
                 <SelectDiv rating={true}>
                  <Label style={{marginLeft:'87px'}}>
                    Calificar*
                  </Label>
                  <SelectComponent>
                    <Rating
                      ref={(rating) => { this.rating = rating }}
                      onRatingChange={rating => this.handleRatingChange(rating)}
                    />
                  </SelectComponent>
                </SelectDiv>
               )}
              <SelectDiv>
                <SelectComponent>
                  <TextInput
                    label="Hora de salida"
                    name="checkout_time"
                    hideEmptyHelpBlock
                    validations={{
                      timeValidation: (values, time) =>
                        /^([01]\d|2[0-3]):([0-5]\d)$/.test(time) ||
                        'Ingresa una hora válida (ej. 15:45)', // eslint-disable-line comma-dangle
                    }}
                    value={moment().format('HH:mm')}
                  />
                </SelectComponent>
              </SelectDiv>
            </CheckoutFormContainer>
          </CheckoutContent>
        </Form>
      </div>
     )
    // : (
    //   <div>
    //       <Form onSubmit={this.send} onChange={this.validateData}>
    //         <HeaderTitle>
    //           <Close>
    //             <Img src="/assets/Close.svg" onClick={this.closeModal} />
    //           </Close>
    //           <HeaderSpan>Formato de salida</HeaderSpan>
    //           <NameHeader>
    //             <Profile profile={child.profile_image} />
    //             <NameSpan>{`${child.first_name} ${child.last_name_paternal}`}</NameSpan>
    //           </NameHeader>
    //           <Save>
    //             <Button
    //               small
    //               style={width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}}
    //               primary
    //               type="submit"
    //               loading={loading}
    //               disabled={disabled}
    //             >
    //               Confirmar
    //             </Button>
    //           </Save>
    //         </HeaderTitle>
    //         <Content>
    //         {/* // descommment to producction */}
    //            {studentIsExternal(child) && (
    //              <SelectDiv>
    //               <Label>Calificar*</Label>
    //               <SelectComponent>
    //                 <Rating
    //                   ref={(rating) => { this.rating = rating }}
    //                   onRatingChange={rating => this.handleRatingChange(rating)}
    //                 />
    //               </SelectComponent>
    //             </SelectDiv>
    //           )}
    //           <SelectDiv>
    //             <Label>Pañales*</Label>
    //             <SelectComponent>
    //               <Select name="diapers" options={optionsDiaper} hideEmptyHelpBlock emptyElement />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Estado de Ánimo</Label>
    //             <SelectComponent>
    //               <Select
    //                 name="mood_id"
    //                 options={mood}
    //                 hideEmptyHelpBlock
    //                 emptyElement
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Cambio de ropa*</Label>
    //             <SelectComponent>
    //               <Select
    //                 name="change_of_clothes"
    //                 options={options}
    //                 emptyElement
    //                 hideEmptyHelpBlock
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Medicamento de Emergencia</Label>
    //             <SelectComponent>
    //               <Select
    //                 name="emergency_medication_id"
    //                 options={medications}
    //                 hideEmptyHelpBlock
    //                 emptyElement
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Accidentes</Label>
    //             <SelectComponent>
    //               <Select
    //                 name="incident_id"
    //                 options={incidentTypes}
    //                 hideEmptyHelpBlock
    //                 emptyElement
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Observaciones</Label>
    //             <SelectComponent>
    //               <TextInput
    //                 name="incident_comments"
    //                 hideEmptyHelpBlock
    //                 textarea
    //                 emptyElement
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //           <SelectDiv>
    //             <Label>Hora de salida</Label>
    //             <SelectComponent>
    //               <TextInput
    //                 name="checkout_time"
    //                 hideEmptyHelpBlock
    //                 validations={{
    //                   timeValidation: (values, time) =>
    //                     /^([01]\d|2[0-3]):([0-5]\d)$/.test(time) ||
    //                     'Ingresa una hora válida (ej. 15:45)', // eslint-disable-line comma-dangle
    //                 }}
    //                 value={moment().format('HH:mm')}
    //               />
    //             </SelectComponent>
    //           </SelectDiv>
    //         </Content>
    //       </Form>
    //    </div>
    // )
  }
}

CheckinModal.propTypes = {
  closeCheckIn: PropTypes.func,
  /** Return the options for selects (diaper, change of clothes and bag) */
  fillOptions: PropTypes.func.isRequired,
}
CheckinModal.defaultProps = {
  closeCheckIn: () => {},
}

const mapStateToProps = state => ({
  checkinInventory: state.checkin_inventory.get.results,
  emergencyMedications: state.emergencyMedications.get.results,
  incidentTypes: state.incidentTypes.get.results,
  mood: state.mood.get.results,
  programLevels: state.programLevels.get.results,
})

const mapDispatchToProps = dispatch => ({
  getCheckinInventory: studentId => dispatch(CheckinInventoryActions.getRequest(studentId, true)),
  fillOptions: length => generateSelectOptions(length),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CheckinModal),
)



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/CheckoutModal.jsx